class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).then(r => r.text()).then(text => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
    }).catch(() => {});
  }
}
customElements.define('product-recommendations', ProductRecommendations);

document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-menu-toggle]').forEach(button => {
  button.addEventListener('click', () => {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = menu.hasAttribute('hidden');
    menu.toggleAttribute('hidden');
    document.body.style.overflow = open ? 'hidden' : '';
    document.querySelectorAll('[data-menu-toggle]').forEach(b => b.setAttribute('aria-expanded', String(open)));
  });
});

document.querySelectorAll('[data-product-form]').forEach(form=>{
 const json=document.getElementById('ProductJson');
 const select=form.querySelector('[data-variant-select]');
 const button=form.querySelector('.product-submit');
 if(!json||!select)return;
 const variants=JSON.parse(json.textContent);
 const groups=[...form.querySelectorAll('.product-option')];

 function updateVariant(){
  const values=groups.map(group=>
   group.querySelector('input[type="radio"]:checked')?.value
  );
  const variant=variants.find(v=>
   v.options.every((value,index)=>value===values[index])
  );
  if(!variant)return;

  select.value=String(variant.id);
const section=form.closest('[data-product-section]');
const price=section?.querySelector('.price-current');
const prefix=section?.querySelector('.price-prefix');

if(price){
 price.textContent=new Intl.NumberFormat('en-AU',{
  style:'currency',
  currency:'AUD'
 }).format(variant.price/100);
}

if(prefix)prefix.style.display='none';
  select.dispatchEvent(new Event('change',{bubbles:true}));
  button.disabled=!variant.available;
  button.textContent=variant.available?'Add to cart':'Sold out';

  const url=new URL(location.href);
  url.searchParams.set('variant',variant.id);
  history.replaceState({},'',url);
 }

 form.querySelectorAll('.option-pills input').forEach(input=>{
  input.addEventListener('change',updateVariant);
 });
 updateVariant();
});